import { quickFacts } from "@/mocks/homeData";

export default function Hero() {
  return (
    <section
      id="top"
      className="relative w-full min-h-[560px] md:min-h-[680px] flex items-center justify-center overflow-hidden"
    >
      <div className="absolute inset-0 w-full h-full">
        <img
          src="https://readdy.ai/api/search-image?query=elegant%20abstract%20artistic%20background%20of%20soft%20peach%20blossom%20petals%20drifting%20in%20warm%20spring%20light%2C%20painterly%20watercolor%20texture%2C%20coral%20rose%20and%20amber%20gold%20gradients%20on%20creamy%20warm%20backdrop%2C%20dreamy%20bokeh%2C%20generous%20empty%20center%20space%20for%20text%2C%20fine%20film%20grain%2C%20refined%20editorial%20aesthetic&width=1920&height=1080&seq=taohua-hero-2026&orientation=landscape"
          alt=""
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/70 via-foreground-950/55 to-foreground-950/75" />

      <div className="relative z-10 w-full px-4 md:px-8 py-24 md:py-28">
        <div className="max-w-4xl mx-auto text-center">
          <span className="inline-flex items-center gap-2 px-3.5 py-1.5 rounded-full bg-background-50/15 border border-background-50/25 text-background-50 text-xs md:text-sm font-label backdrop-blur-sm animate-fade-up">
            <span className="w-1.5 h-1.5 rounded-full bg-accent-400 animate-pulse-soft" />
            入口导航页 · 换域名后请收藏本页
          </span>

          <h1 className="mt-5 font-heading font-black text-balance text-background-50 text-3xl md:text-5xl lg:text-6xl leading-tight md:leading-[1.15] animate-fade-up anim-delay-1">
            桃花视频最新地址
            <span className="block mt-2 text-accent-300">官网入口防走失，永久更新</span>
          </h1>

          <p className="mt-5 max-w-2xl mx-auto text-background-50/85 text-sm md:text-base leading-relaxed animate-fade-up anim-delay-2">
            这里汇总桃花视频的官网入口与最新地址，并在换域名、改版跳转后第一时间同步新链接。
            你只需要记住一件事——<strong className="font-semibold text-background-50">收藏本页</strong>，
            往后无论地址怎么变，都能顺着这里随时找回。
          </p>

          <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-3 animate-fade-up anim-delay-2">
            <a
              href="#bookmark"
              className="inline-flex items-center justify-center gap-2 w-full sm:w-auto px-6 py-3 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-bookmark-3-line text-base" />
              查看收藏防走失方法
            </a>
            <a
              href="#recover"
              className="inline-flex items-center justify-center gap-2 w-full sm:w-auto px-6 py-3 rounded-md bg-background-50/10 border border-background-50/30 text-background-50 text-sm font-medium hover:bg-background-50/20 transition-colors cursor-pointer whitespace-nowrap backdrop-blur-sm"
            >
              <i className="ri-compass-3-line text-base" />
              链接打不开？三步找回
            </a>
          </div>
        </div>

        <div className="mt-12 md:mt-16 max-w-5xl mx-auto grid grid-cols-2 lg:grid-cols-4 gap-3 md:gap-4 animate-fade-up anim-delay-3">
          {quickFacts.map((fact) => (
            <div
              key={fact.label}
              className="rounded-lg bg-background-50/10 border border-background-50/20 backdrop-blur-sm p-3.5 md:p-4 text-left"
            >
              <div className="w-9 h-9 flex items-center justify-center rounded-md bg-accent-500/90 text-foreground-950 text-lg">
                <i className={fact.icon} />
              </div>
              <p className="mt-2.5 text-[11px] md:text-xs text-background-50/70 font-label">{fact.label}</p>
              <p className="text-base md:text-lg font-heading font-bold text-background-50">{fact.value}</p>
              <p className="mt-0.5 text-[11px] md:text-xs text-background-50/60">{fact.note}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}